import { Link } from "react-router-dom";
import { articles } from "@/mocks/articles";
import ArticleCard from "@/components/feature/ArticleCard";

export default function HeroSection() {
  const featured = articles[0];
  const secondary = articles.slice(1, 4);

  return (
    <section className="border-b border-background-200 bg-background-100" aria-label="今日焦点">
      <div className="mx-auto w-full max-w-[1400px] px-4 py-10 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12">
          <div className="lg:col-span-7">
            <p className="mb-4 flex items-center gap-2 text-xs font-medium uppercase tracking-[0.24em] text-accent-700">
              <span className="gw-pulse-dot inline-block h-2 w-2 rounded-full bg-accent-500"></span>
              今日焦点 · 编辑推荐
            </p>
            <h2 className="font-heading text-3xl font-bold leading-tight text-foreground-950 md:text-[2.6rem] md:leading-[1.18]">
              <Link to={`/article/${featured.slug}`} className="hover:text-primary-700">
                {featured.title}
              </Link>
            </h2>
            <p className="mt-4 max-w-2xl text-base leading-relaxed text-foreground-700">{featured.excerpt}</p>

            <div className="mt-5 flex flex-wrap items-center gap-x-4 gap-y-2 text-sm text-foreground-600">
              <span className="rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-800">
                {featured.categoryName}
              </span>
              <span className="flex items-center gap-1">
                <i className="ri-user-3-line" aria-hidden="true"></i>
                {featured.author}
              </span>
              <span className="flex items-center gap-1">
                <i className="ri-calendar-line" aria-hidden="true"></i>
                {featured.date}
              </span>
              <span className="flex items-center gap-1">
                <i className="ri-fire-line text-accent-500" aria-hidden="true"></i>
                热度 {featured.heat.toLocaleString("zh-CN")}
              </span>
            </div>

            <div className="mt-7 h-64 w-full overflow-hidden rounded-lg md:h-80">
              <img
                src={featured.cover}
                alt={`${featured.title} · 瓜网${featured.categoryName}`}
                title={`${featured.title} · 瓜网${featured.categoryName}`}
                className="h-full w-full object-cover object-top"
              />
            </div>
          </div>

          <aside className="lg:col-span-5">
            <div className="mb-5 flex items-center justify-between border-b border-background-300 pb-3">
              <h3 className="font-heading text-lg font-bold text-foreground-950">编辑精选</h3>
              <Link to="/#latest" className="text-sm font-medium text-primary-700 hover:text-primary-800">
                全部资讯 <i className="ri-arrow-right-line" aria-hidden="true"></i>
              </Link>
            </div>
            <div className="flex flex-col gap-6">
              {secondary.map((article) => (
                <ArticleCard key={article.slug} article={article} variant="horizontal" />
              ))}
            </div>

            <div className="mt-7 rounded-lg bg-secondary-100/70 p-5">
              <h4 className="flex items-center gap-2 font-heading text-base font-bold text-secondary-900">
                <i className="ri-megaphone-line" aria-hidden="true"></i>
                有料想爆料？
              </h4>
              <p className="mt-2 text-sm leading-relaxed text-secondary-900/80">
                把你看到的时间、地点和可核实素材发给我们，编辑部会在核实后跟进。
              </p>
              <Link
                to="/contact"
                className="mt-4 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-secondary-600 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-secondary-700"
              >
                前往联系我们
                <i className="ri-arrow-right-line" aria-hidden="true"></i>
              </Link>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}